<template>
  <div>
    <v-dialog v-model="show" max-width="60vh" scrollable>
      <v-card>
        <v-card-title>
          Support Contacts
          <v-spacer></v-spacer>
          <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-data-table
            :headers="tableHeaders"
            :items="supportContacts"
            :items-per-page="10"
          >
            <template v-slot:[`item.Actions`]="{item}">
              <v-btn small icon color="red darken-2" @click="onDeleteClick(item)">
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" small @click="createNewContactDialog = !createNewContactDialog">Add New</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500" v-model="createNewContactDialog">
      <v-card>
        <v-card-title>
          New Support Contact
          <v-spacer></v-spacer>
          <v-btn icon @click="createNewContactDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-autocomplete
            label="Select employee"
            v-model="employee_ID"
            :items="formattedEmployees"
            item-text="full_name"
            item-value="employee_id"
          ></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!employee_ID" @click="createNewContact">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog v-if="deleteContactDialog" v-model="deleteContactDialog" :mode="confirmOrDeniedDialogModes.delete" @onDeleteClick="deleteContact" @onCancelClick="cancelDelete" />
  </div>
</template>

<script>
export default {
  name: 'SupportContactsManager',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: { required: false, type: Boolean, default: false }
  },
  data () {
    return {
      currentItem: null,
      employee_ID: null,
      createNewContactDialog: false,
      supportContacts: [],
      employees: [],
      deleteContactDialog: false,
      tableHeaders: [
        { text: 'User', value: 'fullName', class: 'px-2 text-no-wrap' },
        { text: 'Position', value: 'position', class: 'px-2 text-no-wrap' },
        { text: 'Actions', value: 'Actions', align: 'center', width: 100, sortable: false }
      ]
    }
  },
  mounted () {
    this.getSupportContacts()
    this.getListOfEmployee()
  },
  computed: {
    user () { return this.$store.getters.getUser },
    show: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    },
    confirmOrDeniedDialogModes () { return this.$store.getters.getConfirmOrDeniedDialogModes },
    formattedEmployees () {
      const contactIds = new Set(this.supportContacts.map(c => c.Employee_ID))
      return this.employees.filter(employee => !contactIds.has(employee.employee_id))
    }
  },
  methods: {
    onDeleteClick (item) {
      this.deleteContactDialog = true
      this.currentItem = { ...item }
    },
    cancelDelete () {
      this.deleteContactDialog = false
      this.currentItem = null
    },
    getSupportContacts () {
      this.axios.get('/api/support_contacts', { headers: { Authorization: 'Bearer ' + this.user.token } })
        .then(res => { this.supportContacts = res.data })
        .catch(error => { this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data }) })
    },
    getListOfEmployee () {
      this.axios.get('/api/employeelist', { headers: { Authorization: 'Bearer ' + this.user.token } })
        .then(res => { this.employees = res.data })
        .catch(error => { this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data }) })
    },
    createNewContact () {
      this.axios.post('/api/support_contact', { Employee_ID: this.employee_ID }, { headers: { Authorization: 'Bearer ' + this.user.token } })
        .then(() => {
          this.createNewContactDialog = false
          this.employee_ID = null
          this.getSupportContacts()
          this.$store.dispatch('setSuccess', { successMsg: 'New support contact successfully created' })
        })
        .catch(error => { this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data }) })
    },
    deleteContact () {
      this.axios.delete(`/api/support_contact/${this.currentItem.Support_ID}`, { headers: { Authorization: 'Bearer ' + this.user.token } })
        .then(() => {
          this.cancelDelete()
          this.getSupportContacts()
          this.$store.dispatch('setSuccess', { successMsg: 'Support contact successfully deleted' })
        })
        .catch(error => { this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data }) })
    }
  }
}
</script>
